import { omdApi } from 'bus/api';

import { DriverCreate, DriverQueryParams, DriversListItem } from './types';

const driverTransport = omdApi.injectEndpoints({
  endpoints: (builder) => ({
    getDriverTransportConfigurations: builder.query<DriversListItem[], DriverQueryParams>({
      query: ({ transportId }) => ({
        url: `/v1/DriverTransport/${transportId}/driverConfigurations`,
      }),
    }),
    getDriverTransportList: builder.query<DriversListItem[], DriverQueryParams>({
      query: ({ transportId }) => ({
        url: `/v1/DriverTransport/${transportId}/drivers`,
      }),
    }),
    createDriverTransport: builder.mutation<void, DriverCreate>({
      query: ({ transportId, driverId }) => ({
        url: `/v1/DriverTransport/${transportId}`,
        method: 'POST',
        body: { driverId },
      }),
    }),
    deleteDriverTransport: builder.mutation<void, DriverCreate>({
      query: ({ transportId, driverId }) => ({
        url: `/v1/DriverTransport/${transportId}/${driverId}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useGetDriverTransportConfigurationsQuery,
  useLazyGetDriverTransportConfigurationsQuery,
  useGetDriverTransportListQuery,
  useLazyGetDriverTransportListQuery,
  useCreateDriverTransportMutation,
  useDeleteDriverTransportMutation,
} = driverTransport;
